import {
  TextInput,
  NumberInput,
  ReferenceInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  SelectInput,
  ArrayInput,
  SimpleFormIterator,
  required,
  maxLength,
  minValue,
  AutocompleteInput,
  FormDataConsumer,
  BooleanInput,
  useStore,
} from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import { Grid } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { useEffect, useState } from "react";
import { employeeRequests } from "api/employeeApi";
import { administrationRequests } from "api/administrationApi";
import { specialistRequests } from "api/specialistApi";
import { POSTGRADUATE_FILTERS_KEY } from "../List";

const SaveForm = () => {
  // Read-only consumer of the committed year set on the postgraduate courses list.
  const [filters] = useStore(POSTGRADUATE_FILTERS_KEY, null);
  const defaultYear = filters?.year ?? null;
  const { control } = useFormContext();
  const [definitionIds, setDefinitionIdsIds] = useState([]);

  const courses = useWatch({
    control,
    name: "courses",
  });
  useEffect(() => {
    // filter query
    const ids = courses?.map(item => item?.definitionId)?.filter(Boolean) || [];

    setDefinitionIdsIds(ids);
  }, [courses]);
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <NumberInput
          onWheel={e => e.target.blur()}
          source="year"
          label="Година"
          validate={[required(), minValue(2025, "Въведете валидна година (2025 или по-голяма)")]}
          defaultValue={defaultYear}
          fullWidth
        />
      </Grid>

      <Grid
        item
        xs={12}
      >
        <ArrayInput
          source="courses"
          label="Курсове"
          validate={[required()]}
          defaultValue={[{ isDefinedCourse: true }]}
        >
          <SimpleFormIterator>
            <FormDataConsumer>
              {({ scopedFormData, formData }) => {
                const isDefinedCourse = scopedFormData?.isDefinedCourse;
                return (
                  <Grid
                    container
                    spacing={2}
                  >
                    <Grid
                      item
                      xs={12}
                    >
                      <BooleanInput
                        source="isDefinedCourse"
                        label="Създай нов курс"
                        defaultValue={true}
                      />
                    </Grid>
                    {isDefinedCourse ? (
                      <>
                        <Grid
                          item
                          xs={12}
                          md={6}
                        >
                          <TextInput
                            source="name"
                            label="Име на курса"
                            validate={[required(), maxLength(300)]}
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                        >
                          <ReferenceInput
                            source="typeId"
                            reference={specialistRequests.getPostgraduateCourseTypesSelect()}
                          >
                            <SelectInput
                              optionText={"nameBg"}
                              label="Тип на курса"
                              validate={[required()]}
                              fullWidth
                            />
                          </ReferenceInput>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                        >
                          <ReferenceInput
                            source="clinicId"
                            reference={administrationRequests.getClinicsSelect()}
                          >
                            <SelectInput
                              validate={[required()]}
                              optionText="nameBg"
                              label="Клиника"
                              fullWidth
                            />
                          </ReferenceInput>
                        </Grid>{" "}
                      </>
                    ) : (
                      <Grid
                        item
                        xs={12}
                        md={6}
                      >
                        <ReferenceInput
                          source="definitionId"
                          reference={specialistRequests.getPostgraduateCourseDefinitionsSelect()}
                          filter={{ filterByUser: true, ExcludeIds: definitionIds }}
                        >
                          <AutocompleteInput
                            label="Дефиниция на курс"
                            optionText={rec => `${rec.name} | ${rec.typeNameBg} | ${rec.clinicNameBg}`}
                            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                            fullWidth
                          />
                        </ReferenceInput>
                      </Grid>
                    )}
                    <Grid
                      item
                      xs={12}
                    >
                      <TextInput
                        source="description"
                        label="Описание"
                        validate={[required(), maxLength(2000)]}
                        minRows={5}
                        maxRows={5}
                        fullWidth
                        multiline
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                    >
                      <NumberInput
                        onWheel={e => e.target.blur()}
                        source="durationInCalendarDays"
                        label="Продължителност (дни)"
                        validate={minValue(0)}
                        fullWidth
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                    >
                      <CustomDateInput
                        source="startDate"
                        label="Начална дата"
                        required
                        fullWidth
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                    >
                      <NumberInput
                        onWheel={e => e.target.blur()}
                        source="maxParticipants"
                        label="Максимален брой участници"
                        validate={minValue(0)}
                        defaultValue={0}
                        fullWidth
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                    >
                      <ReferenceArrayInput
                        source="buildingIds"
                        reference={administrationRequests.getBuildingsSelect()}
                      >
                        <AutocompleteArrayInput
                          optionText="name"
                          label="Сгради"
                          validate={[required()]}
                          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                          fullWidth
                        />
                      </ReferenceArrayInput>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                    >
                      <ReferenceArrayInput
                        source="supervisorsEmployeeIds"
                        reference={employeeRequests.getProfessorsSelect()}
                        filter={{ filterByUser: true }}
                      >
                        <AutocompleteArrayInput
                          optionText={rec => `${rec.firstName} ${rec.lastName}`}
                          label="Преподаватели"
                          validate={[required()]}
                          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                          fullWidth
                        />
                      </ReferenceArrayInput>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                    >
                      <TextInput
                        source="note"
                        label="Бележка"
                        validate={[maxLength(1000)]}
                        minRows={5}
                        maxRows={5}
                        fullWidth
                        multiline
                      />
                    </Grid>
                  </Grid>
                );
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  );
};

export default SaveForm;
